import React, { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";

// Muted video that plays on hover (or while on screen with autoInView) and shows a play badge when paused.
export default function HoverVideo({ src, className = "", autoInView = false, testid, poster = 0.1 }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !autoInView) return undefined;
    const io = new IntersectionObserver(([e]) => (e.isIntersecting ? el.play().catch(() => {}) : el.pause()), { threshold: 0.2 });
    io.observe(el);
    return () => io.disconnect();
  }, [autoInView]);
  const play = () => ref.current?.play().catch(() => {});
  const stop = () => { if (!autoInView && ref.current) { ref.current.pause(); } };
  return (
    <span className="relative block w-full h-full group/hv" onMouseEnter={play} onMouseLeave={stop} data-testid={testid}>
      <video ref={ref} src={autoInView ? src : `${src}#t=${poster}`} muted loop playsInline preload="metadata" className={className}
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} />
      <span className={`pointer-events-none absolute inset-0 flex items-center justify-center transition-opacity duration-200 ${playing ? "opacity-0" : "opacity-0 group-hover/hv:opacity-100"}`}>
        <span className="h-11 w-11 rounded-full bg-black/60 backdrop-blur border border-white/20 flex items-center justify-center" data-testid={testid ? `${testid}-play` : undefined}>
          <Play className="w-4 h-4 text-white fill-white ml-0.5" />
        </span>
      </span>
      {!playing && <span className="pointer-events-none absolute bottom-2 right-2 h-6 w-6 rounded-full bg-black/55 flex items-center justify-center group-hover/hv:opacity-0 transition-opacity"><Play className="w-3 h-3 text-white fill-white ml-px" /></span>}
    </span>
  );
}
